<template>
  <!--这里是旧页面-->
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-sm-12" style="padding: 0">
                <div class="col-sm-4" style="padding: 0">
                  <el-input
                    style="
                      border-top-right-radius: 0;
                      border-bottom-right-radius: 0;
                    "
                    v-model="searchParams.searchName"
                    placeholder="Search school name / event title"
                    name="searchName"
                  ></el-input>
                </div>

                <div class="col-sm-2" style="padding: 0" v-if="userRole != 0">
                  <el-button
                    @click="getRequestEventList('isGoFristPage')"
                    type="primary"
                    style="
                      border-top-left-radius: 0;
                      border-bottom-left-radius: 0;
                    "
                    >{{ $t("message.Search") }}</el-button
                  >
                </div>

                <div class="pull-right">
                  <el-radio-group
                    v-model="statusSelected"
                    @change="handleSearchByStatus"
                  >
                    <el-radio-button
                      v-for="item in statusMap"
                      :key="item.statuCode"
                      :label="`${item.statuName} ${item.count}`"
                    ></el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="search-area-bottom">
                <div style="display: flex; padding-left: 0" class="col-sm-9" v-if="userRole == 0">
                  <div class="col-sm-4" style="padding: 0">
                    <el-select
                      v-model="searchParams.districtCode"
                      placeholder="Search district"
                      name="eventDistrictCode"
                      clearable
                      filterable
                      style="
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                      "
                    >
                      <el-option
                        v-for="item in districtGetlist"
                        :key="item.districtCode"
                        :label="item.districtNameEn"
                        :value="item.districtCode"
                      >
                      </el-option>
                    </el-select>
                  </div>
                  <div class="col-sm-2" style="padding: 0">
                    <el-button
                      @click="getRequestEventList('isGoFristPage')"
                      type="primary"
                      style="
                        border-top-left-radius: 0;
                        border-bottom-left-radius: 0;
                      "
                      >{{ $t("message.Search") }}</el-button
                    >
                  </div>
                </div>

                <div v-if="userRole != 0">{{ total }}{{ $t("message.datagridresult") }}</div>
                <el-button size="mini" @click="handleSearchByStatus(null)"
                  >Reset</el-button
                >
              </div>
              <div class="search-area-bottom" v-if="userRole == 0">
                <div>{{ total }}{{ $t("message.datagridresult") }}</div>
              </div>
              <el-table
                :data="requestEventList"
                border
                style="width: 100%"
                ref="multipleTable"
                row-key="id"
                class="rowss"
              >
                <el-table-column
                  sortable
                  prop="createdAt"
                  label="Submit timestamp"
                ></el-table-column>
                <el-table-column prop="schoolName" label="School">
                </el-table-column>
                <el-table-column prop="districtName" label="District">
                </el-table-column>
                <el-table-column prop="eventTitle" label="Event Title">
                </el-table-column>
                <el-table-column
                  sortable
                  prop="startEventDate"
                  label="Request Event Date & Time"
                >
                </el-table-column>
                <el-table-column prop="status" width="80" label="Status">
                  <template slot-scope="scope">
                    <div>{{ statusMap[scope.row.status].statuName }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Action" width="120" fixed="right">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      style="
                        background-color: #409eff;
                        border-color: #409eff;
                        width: 95px;
                      "
                      size="mini"
                      @click="handleToDetail(scope.row)"
                      >view</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="searchParams.pageSize"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      searchParams: {
        yearMonth: "",
        schoolCode: [],
        sourceType: 1,
        status: null,
        searchName: "",
        sortName: "createdAt",
        sortType: "desc",
        pageIndex: 1,
        pageSize: 10,
        districtCode: "",
      },
      districtGetlist: [],
      total: 0,
      statusCount: [],
      requestEventList: [],
      statusSelected: null,
    };
  },
  computed: {
    userInfo() {
      return this.getAuthObj();
    },
    baseURL() {
      return config.domain + "/";
    },
    statusMap() {
      const originalList = [
        { statuCode: 0, statuName: "Pending" },
        { statuCode: 1, statuName: "To follow up" },
        { statuCode: 2, statuName: "Confirmed " },
        { statuCode: 3, statuName: "Rejected" },
      ];
      const res = originalList.map((item) => {
        const itemCount = this.statusCount.find((i) => {
          return i.status == item.statuCode;
        });
        return {
          ...item,
          count: itemCount ? itemCount.count : 0,
        };
      });
      return res;
    },
    userRole() {
      const res = JSON.parse(sessionStorage.getItem("userInfo"));
      return res.roleType;
    },
  },
  created() {},
  mounted() {
    if(this.userRole==0) this.searchParams.districtCode = JSON.parse(sessionStorage.getItem("userInfo")).userDistrictCode
    this.getRequestEventList();
    this.getDistrictGetlist();
  },
  methods: {
    async getDistrictGetlist() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtGetlist", data.data.result);
    },
    async getRequestEventList(isGoFristPage) {
      if (isGoFristPage) this.searchParams.pageIndex = 1;
      const param = {
        ...this.searchParams,
        ...this.userInfo,
        apiUrl: "/schoolEventRequest/getSchoolEventRequests",
      };
      let data = await this.$store.dispatch("apiEvent", param);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.requestEventList = data.data.result.schoolRequest;
      this.statusCount = data.data.result.statusCount;
      this.total = data.data.result.total;
    },
    handleCurrentChange(val) {
      this.searchParams.pageIndex = val;
      this.getRequestEventList();
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.getRequestEventList("isGoFristPage");
    },
    handleToDetail(row) {
      this.$router.push({
        path: "/main/eventRequestDetails",
        query: {
          id: row.id,
        },
      });
    },
    handleSearchByStatus(e) {
      // reset 按钮也用这个方法
      if (!e) {
        this.searchParams.status = null;
        this.statusSelected = null;
      } else {
        const selectedStatu = this.statusMap.find((i) => {
          return e.indexOf(i.statuName) >= 0;
        });
        this.searchParams.status = selectedStatu.statuCode;
      }
      this.getRequestEventList("isGoFristPage");
    },
  },
};
</script>
<style lang="scss" scoped>
.search-area-bottom {
  padding: 10px 0 3px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
</style>
